module.exports = __webpack_public_path__ + "img/btn_bg.779361f7.png";